// extracted by mini-css-extract-plugin
module.exports = {"formsWrap":"Formsccebc701e57d041cb93b70d3810986fb"};